var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGavel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20H12V22H0V20ZM4.24 7.07L7.07 4.24L21.21 18.38L18.38 21.21L4.24 7.07ZM11.32 0L16.98 5.66L14.15 8.49L8.49 2.83L11.32 0ZM2.83 8.48L8.49 14.14L5.66 16.97L0 11.31L2.83 8.48Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGavel);
export default __webpack_public_path__ + "static/media/gavel.631d4fc4175c2a626658dbaf17df7e7e.svg";
export { ForwardRef as ReactComponent };